import { combineReducers } from 'redux';
import Auth from 'documents-lib/js/reducers/Auth';
import Documents from './Documents';
import DocumentsSummary from './DocumentsSummary';
import GoogleDrive from './GoogleDrive';
import View from 'documents-lib/js/reducers/View';
import LegalConsent from 'documents-lib/js/reducers/LegalConsent';
const rootReducer = combineReducers({
  auth: Auth,
  documents: Documents,
  documentsSummary: DocumentsSummary,
  googleDrive: GoogleDrive,
  view: View,
  legalConsent: LegalConsent
});
export default rootReducer;